<div *ngIf="isMobile; else webLogin" class="full-container">
  <!-- <div class="mobile-header">
    <img (click)="navigateTo('market')" src="assets/back_arrow.png" alt="back-button-mobile">
    <div class="mobile-title">
      P2P Bidding
    </div>
    <img class="mobile-logo" src="assets/hygge_hamburger_menu.png" alt="hygge_hamburger_menu">
  </div> -->

  <div *ngIf="isAllocated && activeBid && strikePrice != 0">
    <div class="allocation-container">
      <div class="top-content">
        <div class="bid-card-mobile">
          <div class="bid-details-and-edit">
            <div
              [ngClass]="{
                'type-bid-details-mobile-buy':
                  activeBid.transaction_type === 'Buy',
                'type-bid-details-mobile-sell':
                  activeBid.transaction_type === 'Sell'
              }"
            >
              <span class="type-mobile">{{ activeBid.transaction_type }}</span>
              - Bid details
            </div>
          </div>
          <div
            class="bid-info-mobile"
            [ngClass]="{
              'bid-info-preferential-mobile':
                activeBid.bid_type === 'Preferential Exchange of Energy'
            }"
          >
            <div class="bid-first-column-mobile">
              <div class="top-label-mobile">
                Type <br />
                <span>{{ activeBid.bid_type }}</span>
              </div>
              <div class="bid-values-mobile">
                <span>{{ activeBid.energy_amount }}</span> Units (KWh)
              </div>
            </div>
            <div class="bid-second-column-mobile">
              <div class="top-label-mobile">
                From <br />
                <span>{{ activeBid.from_date }}</span>
              </div>
              <div class="bid-values-mobile">
                &#64; <span>{{ activeBid.bid_price }}</span> Rs.
              </div>
            </div>
          </div>
        </div>
        <div class="middle-content">
          <div class="strike-price-details-mobile">
            <div class="strike-price-label-mobile" *ngIf="!isFixRateBid">
              {{ bidRound.price_label }}
            </div>
            <div class="strike-price-label-mobile" *ngIf="isFixRateBid">
              Price
            </div>
            <div class="strike-price-mobile-currency">
              {{ bidRound.strike_price }}
              <span class="currency-mobile">Rs.</span>
            </div>
          </div>
        </div>
        <div class="energy-allocation-details-mobile">
          <div class="energy-allocation-label-mobile">
            The energy allocation details
          </div>
          <div class="allocation-mobile">
            <div
              [ngClass]="{
                'allocation-grid-buy-mobile':
                  activeBid.transaction_type === 'Buy',
                'allocation-grid-sell-mobile':
                  activeBid.transaction_type === 'Sell'
              }"
            >
              <div class="units-label-mobile">Units</div>
              <div class="traded-label-mobile">Allocated</div>
              <div
                [ngClass]="{
                  'divider-allocation-buy-mobile':
                    activeBid.transaction_type === 'Buy',
                  'divider-allocation-sell-mobile':
                    activeBid.transaction_type === 'Sell'
                }"
              ></div>
              <div
                *ngFor="let trade of bidAllocation"
                class="allocation-data-mobile"
              >
                <div class="unit-value-mobile">{{ trade.units }}</div>
                <div
                  class="seller-name-mobile"
                  *ngIf="activeBid.transaction_type === 'Buy'"
                >
                  Seller - {{ trade.trader }}
                </div>
                <div
                  class="buyer-name-mobile"
                  *ngIf="activeBid.transaction_type === 'Sell'"
                >
                  Buyer - {{ trade.trader }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isAllocated && activeBid && strikePrice != 0">
    <div class="allocation-container">
      <div class="top-content-second-page">
        <div class="bid-card-mobile">
          <div class="bid-details-and-edit">
            <div
              [ngClass]="{
                'type-bid-details-mobile-buy':
                  activeBid.transaction_type === 'Buy',
                'type-bid-details-mobile-sell':
                  activeBid.transaction_type === 'Sell'
              }"
            >
              <span class="type-mobile">{{ activeBid.transaction_type }}</span>
              - Bid details
            </div>
          </div>
          <div
            class="bid-info-mobile"
            [ngClass]="{
              'bid-info-preferential-mobile':
                activeBid.bid_type === 'Preferential Exchange of Energy'
            }"
          >
            <div class="bid-first-column-mobile">
              <div class="top-label-mobile">
                Type <br />
                <span>{{ activeBid.bid_type }}</span>
              </div>
              <div class="bid-values-mobile">
                <span>{{ activeBid.energy_amount }}</span> Units (KWh)
              </div>
            </div>
            <div class="bid-second-column-mobile">
              <div class="top-label-mobile">
                From <br />
                <span>{{ activeBid.from_date }}</span>
              </div>
              <div class="bid-values-mobile">
                &#64; <span>{{ activeBid.bid_price }}</span> Rs.
              </div>
            </div>
          </div>
        </div>
        <div class="middle-content-second-page">
          <div class="strike-price-details-second-page-mobile">
            <div
              class="strike-price-label-second-page-mobile"
              *ngIf="!isFixRateBid"
            >
              {{ bidRound.price_label }}
            </div>
            <div
              class="strike-price-label-second-page-mobile"
              *ngIf="isFixRateBid"
            >
              Price
            </div>
            <div class="strike-price-mobile-second-page-currency">
              {{ bidRound.strike_price }}
              <span class="second-page-currency-mobile">Rs.</span>
            </div>
            <div
              class="accepted-mobile"
              *ngIf="activeBid.status === 'ACCEPTED'"
            >
              ACCEPTED
            </div>
            <div
              class="rejected-mobile"
              *ngIf="activeBid.status === 'REJECTED'"
            >
              REJECTED
            </div>
            <div class="divider-second-page-mobile"></div>
          </div>
          <div class="footer-mobile" *ngIf="activeBid.status === 'ACCEPTED'">
            Please wait for <br />
            the allocation Window <br /><br />
            {{ bidRound.allocation_window }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="activeBid && strikePrice == 0">
    <div class="allocation-container">
      <div class="top-content-third-page">
        <div class="bid-card-mobile">
          <div class="bid-details-and-edit">
            <div
              [ngClass]="{
                'type-bid-details-mobile-buy':
                  activeBid.transaction_type === 'Buy',
                'type-bid-details-mobile-sell':
                  activeBid.transaction_type === 'Sell'
              }"
            >
              <span class="type-mobile">{{ activeBid.transaction_type }}</span>
              - Bid details
            </div>
          </div>
          <div
            class="bid-info-mobile"
            [ngClass]="{
              'bid-info-preferential-mobile':
                activeBid.bid_type === 'Preferential Exchange of Energy'
            }"
          >
            <div class="bid-first-column-mobile">
              <div class="top-label-mobile">
                Type <br />
                <span>{{ activeBid.bid_type }}</span>
              </div>
              <div class="bid-values-mobile">
                <span>{{ activeBid.energy_amount }}</span> Units (KWh)
              </div>
            </div>
            <div class="bid-second-column-mobile">
              <div class="top-label-mobile">
                From <br />
                <span>{{ activeBid.from_date }}</span>
              </div>
              <div class="bid-values-mobile">
                &#64; <span>{{ activeBid.bid_price }}</span> Rs.
              </div>
            </div>
          </div>
        </div>
        <div class="middle-content-third-page">
          <div class="no-strike-price-mobile">
            There is no {{ bidRound.price_label }}, <br />
            Only you place a bid for this bidding round.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #webLogin>
  <div class="container">
    <div *ngIf="isAllocated && activeBid && strikePrice != 0" class="content">
      <div class="bid-details">
        <div class="bid-info">
          <div class="column">
            <div class="bid-card">
              <div class="card-content">
                <div
                  class="bid-type"
                  [ngClass]="{
                    'buy-class': activeBid.transaction_type === 'Buy',
                    'sell-class': activeBid.transaction_type === 'Sell'
                  }"
                >
                  <span>Bid Type</span>:
                  <span>{{ activeBid.transaction_type }}</span>
                </div>
                <div class="strike-price">
                  <div class="price-label" *ngIf="!isFixRateBid">
                    {{ bidRound.price_label }} :
                  </div>
                  <div class="price-label" *ngIf="isFixRateBid">Price :</div>
                  <div class="price-value">
                    {{ bidRound.strike_price }} <span class="currency">Rs</span>
                  </div>
                </div>
                <div class="separator"></div>
                <div class="bid-title">Your Bid Details</div>
                <div class="separator"></div>
              </div>
              <div class="bid">
                <div class="label">Bid Category</div>
                <div class="label-2">{{ activeBid.bid_type }}</div>
              </div>
              <div class="bid-data">
                <div class="data-label">Number of Units [Kwh]</div>
                <div class="data-value">{{ activeBid.energy_amount }}</div>
              </div>
              <div class="bid-date">
                <div class="date-label">From Date</div>
                <div class="rate-value">
                  {{ formatTradeTimeYear(activeBid.from_date) }}
                </div>
              </div>
              <div *ngIf="isFixRateBid" class="bid-date">
                <div class="date-label">To Date</div>
                <div class="rate-value">
                  {{ formatTradeTimeYear(activeBid.trade_end) }}
                </div>
              </div>
              <div class="bid-timing">
                <div class="timing-label">
                  {{ activeBid.transaction_type }} Bid rate [Rs.]
                </div>
                <div class="rate-label">{{ activeBid.bid_price }}</div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="allocation-card">
              <div class="allocation-content">
                <div class="allocation-title">
                  The energy allocation details<br />for your
                  <label *ngIf="activeBid.transaction_type === 'Buy'"
                    >requirement</label
                  >
                  <label *ngIf="activeBid.transaction_type === 'Sell'"
                    >supply</label
                  >
                </div>
                <div class="separator"></div>
                <div class="allocation-">
                  <div class="label-1">Units</div>
                  <div
                    class="label-1"
                    *ngIf="activeBid.transaction_type === 'Buy'"
                  >
                    From Seller
                  </div>
                  <div
                    class="label-1"
                    *ngIf="activeBid.transaction_type === 'Sell'"
                  >
                    To Buyer
                  </div>
                </div>
                <div class="separator"></div>
                <div class="allocation-data-container">
                  <div
                    *ngFor="let trade of bidAllocation"
                    class="allocation-data"
                  >
                    <div class="data-units">
                      <div class="unit-value">{{ trade.units }}</div>
                    </div>
                    <div class="data-sellers">
                      <div class="seller-info">
                        <div
                          class="seller-name"
                          *ngIf="activeBid.transaction_type === 'Buy'"
                        >
                          Seller - {{ trade.trader }}
                        </div>
                        <div
                          class="seller-name"
                          *ngIf="activeBid.transaction_type === 'Sell'"
                        >
                          Buyer - {{ trade.trader }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!isAllocated && activeBid && strikePrice != 0" class="main">
      <div class="main-content">
        <div
          class="bid-type waitting"
          [ngClass]="{
            'buy-class': activeBid.transaction_type === 'Buy',
            'sell-class': activeBid.transaction_type === 'Sell'
          }"
        >
          <span>Bid Type</span>:
          <span>{{ activeBid.transaction_type }}</span>
        </div>
        <div class="bid-status">
          <div class="bid-status-title">Bid Status</div>
          <div
            [ngClass]="{
              'bid-status-pending': activeBid.status === 'PENDING',
              'bid-status-active': activeBid.status === 'ACTIVE',
              'bid-status-accepted': activeBid.status === 'ACCEPTED',
              'bid-status-rejected': activeBid.status === 'REJECTED',
              'bid-status-cancelled': activeBid.status === 'CANCELLED'
            }"
            *ngIf="activeBid.status"
          >
            <img
              class="green-dot"
              *ngIf="activeBid.status === 'ACTIVE'"
              src="assets/green-dot.svg"
              alt="green dot"
            />
            <img
              class="green-dot"
              *ngIf="activeBid.status === 'ACCEPTED'"
              src="assets/green-dot.svg"
              alt="green dot"
            />
            <img
              class="yellow-dot"
              *ngIf="activeBid.status === 'PENDING'"
              src="assets/yellow-dot.svg"
              alt="yellow dot"
            />
            <img
              class="red-dot"
              *ngIf="
                activeBid.status === 'REJECTED' ||
                activeBid.status === 'CANCELLED'
              "
              src="assets/red-dot.svg"
              alt="red dot"
            />
            {{ activeBid.status }}
          </div>
        </div>
        <div class="bid-info-web" *ngIf="activeBid.status === 'REJECTED'">
          <div class="bid-column-web">
            <div class="label-web">
              Type <br />
              <span>{{ activeBid.bid_type }}</span>
            </div>
            <div class="values-web">
              <span>{{ activeBid.energy_amount }}</span> Units (KWh)
            </div>
          </div>
          <div class="bid-column-web">
            <div class="label-web">
              From <br />
              <span>{{ activeBid.from_date }}</span>
            </div>
            <div class="values-web">
              &#64; <span>{{ activeBid.bid_price }}</span> Rs.
            </div>
          </div>
        </div>
        <div *ngIf="activeBid.status === 'CANCELLED'">
          <div class="withdrawn">Your bid has been withdrawn</div>
        </div>
        <div *ngIf="activeBid.status !== 'CANCELLED'">
          <div class="main-content-row">
            <div class="main-content-label" *ngIf="!isFixRateBid">
              {{ bidRound.price_label }} :
            </div>
            <div class="main-content-label" *ngIf="isFixRateBid">Price :</div>
            <div class="main-content-value">
              {{ bidRound.strike_price }}
              <span style="font-weight: 400; font-size: 32px">Rs</span>
            </div>
          </div>
          <div class="accepted" *ngIf="activeBid.status === 'ACCEPTED'">
            ACCEPTED
          </div>
          <div class="rejected" *ngIf="activeBid.status === 'REJECTED'">
            REJECTED
          </div>
          <div class="pending" *ngIf="activeBid.status === 'PENDING'">
            PENDING
          </div>
          <div class="seperator"></div>
          <div
            class="footer"
            *ngIf="activeBid.status === 'ACCEPTED' || 'PENDING'"
          >
            Please wait for the allocation Window
            <br /><br />
            {{ bidRound.allocation_window }}
          </div>
          <button class="home-button" (click)="goHome()">Home</button>
        </div>
      </div>
    </div>

    <div *ngIf="activeBid && strikePrice == 0 && isFixRateBid" class="main">
      <div class="main-content">
        <div
          class="bid-type waitting"
          [ngClass]="{
            'buy-class': activeBid.transaction_type === 'Buy',
            'sell-class': activeBid.transaction_type === 'Sell'
          }"
        >
          <span>Bid Type</span>:
          <span>{{ activeBid.transaction_type }}</span>
        </div>
        <div class="bid-info-web" *ngIf="activeBid.status === 'REJECTED'">
          <div class="bid-column-web">
            <div class="label-web">
              Type <br />
              <span>{{ activeBid.bid_type }}</span>
            </div>
            <div class="values-web">
              <span>{{ activeBid.energy_amount }}</span> Units (KWh)
            </div>
          </div>
          <div class="bid-column-web">
            <div class="label-web">
              From <br />
              <span>{{ activeBid.from_date }}</span>
            </div>
            <div class="values-web">
              &#64; <span>{{ activeBid.bid_price }}</span> Rs.
            </div>
          </div>
        </div>
        <div class="main-content-row">
          <div class="main-content-label" *ngIf="!isFixRateBid">
            {{ bidRound.price_label }} :
          </div>
          <div class="main-content-label" *ngIf="isFixRateBid">Price :</div>
          <div class="main-content-value">
            {{ bidRound.strike_price }}
            <span style="font-weight: 400; font-size: 32px">Rs</span>
          </div>
        </div>
        <div class="accepted" *ngIf="activeBid.status === 'ACCEPTED'">
          ACCEPTED
        </div>
        <div class="rejected" *ngIf="activeBid.status === 'REJECTED'">
          REJECTED
        </div>
        <div class="seperator"></div>
        <div class="footer" *ngIf="activeBid.status === 'ACCEPTED'">
          Please wait for the allocation Window
          <br /><br />
          {{ bidRound.allocation_window }}
        </div>
        <button class="home-button" (click)="goHome()">Home</button>
      </div>
    </div>

    <div *ngIf="activeBid && strikePrice == 0 && !isFixRateBid" class="main">
      <div class="main-content">
        <div
          class="bid-type waitting"
          [ngClass]="{
            'buy-class': activeBid.transaction_type === 'Buy',
            'sell-class': activeBid.transaction_type === 'Sell'
          }"
        >
          <span>Bid Type</span>:
          <span>{{ activeBid.transaction_type }}</span>
        </div>
        <div class="main-content-row">
          <div class="main-content-label">
            There is no {{ bidRound.price_label }}; only you place a bid for
            this bidding round
          </div>
        </div>
        <button class="home-button" (click)="goHome()">Home</button>
      </div>
    </div>
  </div>
</ng-template>
